interface VipStatusBadgeProps {
  status: 'member' | 'vip'
}

export function VipStatusBadge({ status }: VipStatusBadgeProps) {
  const label = status === 'vip' ? 'VIP' : 'Member'

  return (
    <div className="bg-white/80 rounded-3xl py-4 px-6">
      <h2 className="text-4xl font-bold text-amber-400 tracking-wide">
        {label}
      </h2>
      <p className="text-sm text-gray-400 mt-1">Current Status</p>
    </div>
  )
}
